import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class MpesaService {
    private baseApiUrl: string;

    constructor (configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
      sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true): Observable<any> {

      const params = {
        filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
      };

      return this.httpClient.post(this.baseApiUrl + 'mpesa_payment_notification/', params).pipe(
        map((res: any) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getAll(forMaintenance: boolean = false): Observable<any> {
       return this.httpClient.get(this.baseApiUrl + `mpesa_payment_notification?isMaintenance=${forMaintenance}`).pipe(
        map((res: any) =>  res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `mpesa_payment_notification/${id}?isMaintenance=${forMaintenance}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

   

   

    delete(id: number): Observable<any> {
      return this.httpClient.delete(this.baseApiUrl + `mpesa_payment_notification/${id}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
  }
